import { render, staticRenderFns } from "./ButtonsBrowse.vue?vue&type=template&id=f448c45a&scoped=true"
import script from "./ButtonsBrowse.vue?vue&type=script&lang=js"
export * from "./ButtonsBrowse.vue?vue&type=script&lang=js"
import style0 from "./ButtonsBrowse.vue?vue&type=style&index=0&id=f448c45a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f448c45a",
  null
  
)

export default component.exports